<template lang="pug">
    div
        //- span.title {{moment("2019-03-01", "YYYY-MM-DD")}}
        .title Monto:
        v-text-field.title#check-pay-input(
                ref="amountInput"
                :mask="mixCurrencyMask(checkPayment, 12)"
                placeholder="Ingrese monto del cheque"
                prefix="$"
                v-model="checkPayment"
                @keyup.enter="handleEnter()"
                :rules='[rules.required, rules.validPayment, rules.notZero]')
                //- @input="setPayment(checkPayment)")
        v-divider

        .title Banco:
        v-autocomplete.title(
            ref="bankInput"
            label="Seleccione tipo de cheque"
            :items="banks"
            item-text="bank"
            item-value="id"
            v-model="bankId"
            @change="handleEnter()"
            :rules='[rules.required]')
        v-divider
        
        .title Número de plaza
        v-text-field.title(solo
            ref="plazaInput"
            placeholder="Ingrese n° de plaza"
            v-model="plaza"
            @keyup.enter="handleEnter()"
            :rules='[rules.required]' validate-on-blur
            mask="#######")
        v-divider
        
        .title Número de cuenta
        v-text-field.title(solo
            ref="accountInput"
            placeholder="Ingrese n° cuenta"
            v-model="accountNumber"
            @keyup.enter="handleEnter()"
            @blur="accountNumber = fillWithZeros(accountNumber, 12)"
            :rules='[rules.required, rules.accountNumber]' validate-on-blur
            mask="##################")
        v-divider

        .title Número serial cheque
        v-text-field.title(solo
            ref="serialInput"
            placeholder="Ingrese serial del cheque"
            v-model="serialNumber"
            @keyup.enter="handleEnter()"
            @blur="serialNumber = fillWithZeros(serialNumber, 9)"
            :rules='[rules.required, rules.serial]' validate-on-blur
            mask="NNN-NNN-NNN")
        v-divider

        .title Tipo de cheque
        v-select.title(label="Seleccione tipo de cheque"
            ref="checkTypeInput"
            :items="checkTypesList"
            item-text="text"
            item-value="id"
            v-model="checkType"
            @change="handleEnter()"
            :rules='[rules.required]')
        v-divider

        div(v-if="checkType===1")
            .title Fecha para cobrar:
            v-menu.title(
                ref='chargeMenu'
                :close-on-content-click='false'
                v-model='chargeMenu'
                :nudge-right='40'
                lazy
                transition='scale-transition'
                offset-y
                full-width
                max-width='290px'
                min-width='290px')
                v-text-field.title(
                    ref="chargeInput"
                    @change="handleEnter()"
                    slot='activator'
                    v-model='chargeDate'
                    label='Seleccione fecha para cobrar'
                    prepend-icon='event')
                v-date-picker.title(
                    v-model='chargeDate'
                    no-title
                    @input='chargeMenu = false'
                    :allowed-dates="allowedDates")
        v-divider
</template>

<script>
// Components:
import RUTInput from '@/components/RUTInput/RUTInput'

// Mixins:
import PaymentRules from '@/mixins/PaymentRules'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import DateUtils from '@/mixins/DateUtils'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'check-payment',
    props: {},
    data: function() {
        return {
            // bankList: [ {id: 1, bank: 'Banco de Chile'},
            //             {id: 2, bank: 'BBVA'}],
            bankId: '',

            accountNumber: '',
            plaza: '',
            checkTypeId: '',

            checkTypesList: [
                { text: 'Cheque a fecha', id: 1 },
                { text: 'Cheque al día', id: 2 },
            ],
            checkType: '', // Cheque a fecha (1) o Cheque al día (2)

            serialNumber: '',
            rut: '',
            validRut: false,
            name: '',

            // Data related to release date of check:
            // releaseMenu: false,
            releaseDate: new Date().toISOString().substr(0, 10),
            // dateAux: new Date(),

            // Data related to charge date of check:
            chargeMenu: false,
            chargeDate: '',
            checkPayment: '',
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            total: state => state.total,
            banks: state => state.banks,
        }),

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
        }),

        allCheckDataSet() {
            let allSet =
                this.checkType != '' &&
                // this.validRut &&
                // this.name != '' &&
                ((this.chargeDate != '' && this.checkType === 1) ||
                    this.checkType === 2) &&
                this.checkPayment != '' &&
                this.checkPayment <= this.totalToPay &&
                this.serialNumber.length === 9 &&
                parseInt(this.serialNumber) !== 0 &&
                this.bankId != '' &&
                this.accountNumber.length > 0 &&
                parseInt(this.accountNumber) !== 0 &&
                this.plaza != ''
            // if (allSet) {
            //     this.setPayment(this.checkPayment)
            //     let lengthRut = this.rut.length
            //     let rutAux =
            //         this.rut.slice(0, lengthRut - 1) +
            //         '-' +
            //         this.rut.slice(lengthRut - 1)
            //     let payload = {
            //         // checkTypeId: this.checkType,
            //         // rut: rutAux,
            //         // name: this.name,
            //         // releaseDate: new Date(),
            //         // chargeDate: this.chargeDate,
            //         // serialNumber: this.serialNumber,
            //         bankId: this.bankId,
            //         accountNumber: this.accountNumber,
            //         plaza: this.plaza,
            //         checkTypeId: this.checkType,
            //         chargeDate: this.chargeDate,
            //         serialNumber: this.serialNumber,
            //     }
            //     this.setPayment(this.checkPayment)
            //     this.setPaymentDetail(payload)
            // } else {
            //     this.setPayment('')
            //     this.setPaymentDetail(null)
            // }
            return allSet
        },
    },
    methods: {
        allowedDates: function(val) {
            let futureDate = new Date()
            futureDate = new Date(
                futureDate.setTime(futureDate.getTime() + 120 * 86400000)
            )
            return (
                val > this.releaseDate &&
                val <= futureDate.toISOString().substr(0, 10)
            )
        },
        ...mapActions('CashDeskModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
            setBanks: 'setBanks',
        }),
        updateRut: function(newVal) {
            this.rut = newVal
        },

        updateValidRut: function(newVal) {
            this.validRut = newVal
        },

        setCheckPayment: function() {
            if (parseInt(this.checkPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.checkPayment)
            }
        },

        focusByRef(ref) {
            this.$nextTick(() => this.$refs[ref].focus())
        },

        handleEnter() {
            if (!this.checkPayment) {
                this.focusByRef('amountInput')
                console.log(1)
                return
            } else if (!this.bankId) {
                this.focusByRef('bankInput')
                console.log(2)
                return
            } else if (!this.plaza) {
                this.focusByRef('plazaInput')
                console.log(3)
                return
            } else if (!this.accountNumber) {
                this.focusByRef('accountInput')
                console.log(4)
                return
            } else if (!this.serialNumber) {
                this.focusByRef('serialInput')
                console.log(5)
                return
            } else if (!this.checkType) {
                this.focusByRef('checkTypeInput')
                console.log(6)
                return
            } else if (this.checkType === 1 && !this.chargeDate) {
                this.$nextTick(() => this.$refs.chargeInput.$el.click)
                console.log(7)
                return
            } else {
                // this.$emit('confirm')
                // console.log(8)
            }
        },
        fillWithZeros(num, length){
            let n = '' + num
            let len = n.length
            let diff = length - len
            console.log(n, len, diff)
            if(diff){
                for(let i = 0; i < diff; i++){
                    n = '0' + n
                }
            }
            return n
        }
    },
    watch: {
        /**
         * @description
         */
        allCheckDataSet: function(newVal, oldVal) {
            if (newVal) {
                this.setPayment(this.checkPayment)
                let lengthRut = this.rut.length
                let rutAux =
                    this.rut.slice(0, lengthRut - 1) +
                    '-' +
                    this.rut.slice(lengthRut - 1)
                let payload = {
                    // checkTypeId: this.checkType,
                    // rut: rutAux,
                    // name: this.name,
                    // releaseDate: new Date(),
                    // chargeDate: this.chargeDate,
                    // serialNumber: this.serialNumber,
                    bankId: this.bankId,
                    accountNumber: this.accountNumber,
                    plaza: this.plaza,
                    checkTypeId: this.checkType,
                    chargeDate: this.chargeDate,
                    serialNumber: this.serialNumber,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },
    },
    components: { 'rut-input': RUTInput },
    mixins: [PaymentRules, CurrencyUtils, DateUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){},
    // beforeMount: function(){...},
    mounted: async function() {
        // this.checkPayment = this.totalToPay.toString()
        this.setCheckPayment()
        await this.setBanks()
        // this.$nextTick(() => document.getElementById('check-pay-input').focus())
        this.focusByRef('amountInput')
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.title {
    margin: 10px;
}
</style>